import { AttributePrototypesResponse } from "@/models/api/administration/servicesAndAttributes/AttributePrototype";
import {
  AttributePrototypeMapperResponse,
  MapperSuggestion,
} from "@/models/api/administration/servicesAndAttributes/AttributePrototypeMapper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import CancellableHelper from "@/requests/CancellableHelper";

// Routes
export const URL_GET_CONTRACTOR_ATTRIBUTE_PROTOTYPES = "/ContractorAdministration/Mappers/Prototypes";
export const URL_GET_CONTRACTOR_MAPPERS = "/ContractorAdministration/${ContractorId}/Mappers/${AttributePrototypeId}";
export const URL_GET_CONTRACTOR_MAPPER_SUGGESTIONS =
  "/ContractorAdministration/Mappers/${AttributePrototypeId}/Suggestions";
export const URL_POST_ADD_CONTRACTOR_MAPPERS_FROM_SUGGESTIONS =
  "/ContractorAdministration/${ContractorId}/Mappers/${AttributePrototypeId}/Add/Suggestions";
export const URL_POST_ADD_CONTRACTOR_MAPPER =
  "/ContractorAdministration/${ContractorId}/Mappers/${AttributePrototypeId}/Add";
export const URL_POST_ADD_CONTRACTOR_MAPPERS =
  "/ContractorAdministration/${ContractorId}/Mappers/${AttributePrototypeId}/Add/Multiple";
export const URL_POST_REMOVE_CONTRACTOR_MAPPER =
  "/ContractorAdministration/Mappers/${AttributePrototypeId}/${AttributeMapperId}/Remove";
export const URL_POST_EDIT_CONTRACTOR_MAPPER =
  "/ContractorAdministration/Mappers/${AttributePrototypeId}/${AttributeMapperId}/Edit";

// Requests
const _getContractorAttributePrototypes = new CancellableHelper<AttributePrototypesResponse>(
  URL_GET_CONTRACTOR_ATTRIBUTE_PROTOTYPES,
  AttributePrototypesResponse
);
_getContractorAttributePrototypes.jsonSerializer = true;
export const getContractorAttributePrototypes = async (
  genericTableRequest: GenericTableRequest
): Promise<AttributePrototypesResponse> => {
  return await _getContractorAttributePrototypes.get(genericTableRequest);
};

const _getContractorMappers = new CancellableHelper<AttributePrototypeMapperResponse>(
  URL_GET_CONTRACTOR_MAPPERS,
  AttributePrototypeMapperResponse
);
_getContractorMappers.jsonSerializer = true;
export const getContractorMappers = async (
  contractorId: string,
  attributePrototypeId: number,
  genericTableRequest: GenericTableRequest
): Promise<AttributePrototypeMapperResponse> => {
  return await _getContractorMappers.get({
    ContractorId: contractorId,
    AttributePrototypeId: attributePrototypeId,
    ...genericTableRequest,
  });
};

const _getContractorMapperSuggestions = new CancellableHelper<Array<MapperSuggestion>>(
  URL_GET_CONTRACTOR_MAPPER_SUGGESTIONS,
  MapperSuggestion
);
export const getContractorMapperSuggestions = async (
  attributePrototypeId: number
): Promise<Array<MapperSuggestion>> => {
  return await _getContractorMapperSuggestions.get({
    AttributePrototypeId: attributePrototypeId,
  });
};

const _addContractorMappersFromSuggestions = new CancellableHelper<null>(
  URL_POST_ADD_CONTRACTOR_MAPPERS_FROM_SUGGESTIONS,
  null,
  true
);
export const addContractorMappersFromSuggestions = async (
  contractorId: string,
  attributePrototypeId: number,
  suggestions: Array<MapperSuggestion>
): Promise<null> => {
  return await _addContractorMappersFromSuggestions.post(
    { ContractorId: contractorId, AttributePrototypeId: attributePrototypeId },
    suggestions
  );
};

const _addContractorMapper = new CancellableHelper<null>(URL_POST_ADD_CONTRACTOR_MAPPER, null, true);
export const addContractorMapper = async (
  contractorId: string,
  attributePrototypeId: number,
  model: MapperSuggestion
): Promise<null> => {
  return await _addContractorMapper.post(
    { ContractorId: contractorId, AttributePrototypeId: attributePrototypeId },
    model
  );
};

const _addContractorMappers = new CancellableHelper<null>(URL_POST_ADD_CONTRACTOR_MAPPERS, null, true);
export const addContractorMappers = async (
  contractorId: string,
  attributePrototypeId: number,
  attributeMappersIds: Array<number>
): Promise<null> => {
  return await _addContractorMappers.post(
    { ContractorId: contractorId, AttributePrototypeId: attributePrototypeId },
    { MapperAttributeId: attributeMappersIds }
  );
};

const _removeContractorMapper = new CancellableHelper<null>(URL_POST_REMOVE_CONTRACTOR_MAPPER, null, true);
export const removeContractorMapper = async (
  attributePrototypeId: number,
  attributeMapperId: number
): Promise<null> => {
  return await _removeContractorMapper.post({
    AttributePrototypeId: attributePrototypeId,
    AttributeMapperId: attributeMapperId,
  });
};

const _editContractorMapper = new CancellableHelper<null>(URL_POST_EDIT_CONTRACTOR_MAPPER, null, true);
export const editContractorMapper = async (
  attributePrototypeId: number,
  model: MapperSuggestion,
  attributeMapperId: number
): Promise<null> => {
  return await _editContractorMapper.post(
    {
      AttributePrototypeId: attributePrototypeId,
      AttributeMapperId: attributeMapperId,
    },
    model
  );
};
